import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M7.96972 5.00048C7.96972 3.35748 6.63372 2.02148 4.99072 2.02148C3.34772 2.02148 2.01172 3.35848 2.01172 5.00048C2.01172 6.64248 3.34772 7.97948 4.99072 7.97948C6.63372 7.97948 7.96972 6.64348 7.96972 5.00048ZM4.01172 5.00048C4.01172 4.46048 4.45072 4.02148 4.99072 4.02148C5.53072 4.02148 5.96972 4.46048 5.96972 5.00048C5.96972 5.54048 5.53072 5.97948 4.99072 5.97948C4.45072 5.97948 4.01172 5.54148 4.01172 5.00048Z" }), jsx("path", { fill: "currentColor", d: "M19.9466 7.42873L19.2396 6.72173C17.9226 5.40473 16.1646 4.67773 14.2896 4.67773C12.4146 4.67773 10.6576 5.40473 9.33963 6.72173L7.21863 8.84273C5.26863 10.7917 5.26863 13.9647 7.21863 15.9137L7.92563 16.6207L4.39062 20.1557L6.51163 22.2767L10.0476 18.7407L10.7556 19.4477C11.6966 20.3887 12.9516 20.9077 14.2906 20.9077C15.6296 20.9077 16.8846 20.3887 17.8266 19.4477L19.9476 17.3267C21.2646 16.0097 21.9906 14.2517 21.9906 12.3767C21.9906 10.5017 21.2646 8.74473 19.9476 7.42773L19.9466 7.42873ZM18.5326 15.9137L16.4116 18.0347C15.2856 19.1617 13.2956 19.1617 12.1686 18.0347L8.63263 14.4997C7.46263 13.3297 7.46263 11.4267 8.63263 10.2567L10.7536 8.13573C11.6936 7.19673 12.9486 6.67773 14.2896 6.67773C15.6306 6.67773 16.8856 7.19673 17.8256 8.13573L18.5326 8.84273C19.4716 9.78173 19.9896 11.0377 19.9896 12.3777C19.9896 13.7177 19.4716 14.9737 18.5326 15.9137Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconPingPong = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconPingPong.displayName = "IconPingPong";

export { IconPingPong };
